import { useContext, useEffect } from 'react';

import PlanningEmployee from '@/components/planning/planning-employee/PlanningEmployee';
import PlanningManager from '@/components/planning/planning-manager/PlanningManager';
import { UserRoleContext } from '@/context/RoleContext';

import classes from './PlanningPage.module.scss';

const PlanningPage = () => {
	useEffect(() => {
		document.title = 'ERP - Planning';
	}, []);

	const { userRoleContext } = useContext(UserRoleContext);

	return userRoleContext.data?.can_create_project ? (
		<section className={classes.container}>
			<PlanningManager />
		</section>
	) : (
		<section className={classes.mainContainer}>
			<PlanningEmployee />
		</section>
	);
};

export default PlanningPage;
